const FormField = {
  backgroundColor: 'white',
  boxShadow: '0px 5px 5px -5px #000',
};

export { FormField };
